import { API_URL as API } from '../api';

const authProvider = {
  login: async ({ username, password }) => {
    const res = await fetch(`${API}/auth/login`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ username, password }),
    });

    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || 'שם משתמש או סיסמא שגויים');
    }

    const { token, user } = await res.json();
    localStorage.setItem('auth_token', token);
    localStorage.setItem('auth_user',  JSON.stringify(user));
  },

  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    return Promise.resolve();
  },

  checkAuth: () =>
    localStorage.getItem('auth_token') ? Promise.resolve() : Promise.reject(),

  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: () => {
    try {
      const user = JSON.parse(localStorage.getItem('auth_user') || '{}');
      return Promise.resolve({ id: user.id, fullName: user.username });
    } catch {
      return Promise.reject();
    }
  },

  getPermissions: () => {
    try {
      const user = JSON.parse(localStorage.getItem('auth_user') || '{}');
      return Promise.resolve(user.role || 'staff');
    } catch {
      return Promise.resolve('staff');
    }
  },
};

export default authProvider;
